import { PriceDropZonesEnum } from '@enums/price-drop/price-zones';
import { ConversionUnderPriceBanner } from './conversion-under-price-banner/ConversionUnderPriceBanner';
import { ConversionAtPriceBanner } from './conversion-at-price-banner/ConversionAtPriceBanner';
import { ConversionWellPriceBanner } from './conversion-well-price-banner/ConversionWellPriceBanner';
import { ConversionOverPriceBanner } from './conversion-over-price-banner/ConversionOverPriceBanner';
import { ConversionVeryOverPriceBanner } from './conversion-very-over-price-banner/ConversionVeryOverPriceBanner';

type PriceBannerVariantProps = {
  priceDropZone: PriceDropZonesEnum;
  showLearnMoreButton: boolean;
  recommendedPrice: string;
  showRecommendedPriceButton: boolean;
  onClickRecommendedPrice: () => void;
  onClickLearnMore: () => void;
};

export const PriceBannerVariant = ({ priceDropZone, ...props }: PriceBannerVariantProps) => {
  if (
    [PriceDropZonesEnum.CONVERSION_VERY_UNDERPRICED, PriceDropZonesEnum.CONVERSION_UNDERPRICED].includes(priceDropZone)
  ) {
    return <ConversionUnderPriceBanner {...props} />;
  }
  if (priceDropZone === PriceDropZonesEnum.CONVERSION_AT_PRICE) {
    return <ConversionAtPriceBanner {...props} />;
  }
  if (priceDropZone === PriceDropZonesEnum.CONVERSION_WELL_PRICED) {
    return <ConversionWellPriceBanner {...props} />;
  }
  if (priceDropZone === PriceDropZonesEnum.CONVERSION_OVERPRICED) {
    return <ConversionOverPriceBanner {...props} />;
  }
  if (priceDropZone === PriceDropZonesEnum.CONVERSION_VERY_OVERPRICED) {
    return <ConversionVeryOverPriceBanner {...props} />;
  }
};
